module.exports = __webpack_public_path__ + "media/assets/images/synchronizing_green-8ccd23f938dcc2d6cdf9e5c460104781.png";